import React from 'react'
import Image from 'next/image'
import { Box, Button } from '@mui/material'
import { Model } from 'src/types'
import { useLocale } from 'src/locales/useLocale'
import { borderStyle } from 'src/style/muiTheme'

type Props = {
  model: Model
  selectedModel: Model
  setSelectedModel: React.Dispatch<React.SetStateAction<Model>>
}

export const ModelCard: React.FC<Props> = ({ model, selectedModel, setSelectedModel }) => {
  const { t } = useLocale()
  const isSelected = selectedModel?.productNumber === model.productNumber
  return (
    <Box p={1}>
      <Button
        data-testid={'model-card-button'}
        variant={isSelected ? 'contained' : 'outlined'}
        color={isSelected ? 'primary' : 'inherit'}
        style={{ maxWidth: '250px', border: borderStyle }}
        onClick={() => setSelectedModel(model)}
      >
        <Box component={'span'} style={{ maxWidth: '300px', display: 'inline-block' }}>
          <Image src={model.imageUrl} alt={model.productNumber} width={model.imageWidth} height={model.imageHeight} />
          <Box component={'h4'}>
            <Box>
              {t.PRODUCT_NUMBER}
              {model.productNumber}
            </Box>
            <Box fontSize={'12px'}>{model?.subProductNumber && `(${model.subProductNumber})`}</Box>
          </Box>
          {model.size > 0 && <Box textTransform={'none'}>{`${model.size} ${t.SIZE_UNIT}`}</Box>}
          <Box textTransform={'none'} sx={{ whiteSpace: 'pre-line' }}>{model.description}</Box>
        </Box>
      </Button>
    </Box>
  )
}
